<script setup lang="ts">
import SearchList from '@pages/search/components/SearchList.vue';
import SearchMap from '@pages/search/components/SearchMap.vue';
import SearchFilters from '@pages/search/components/SearchFilters.vue';
import { storeToRefs } from 'pinia';
import { useSearchStore } from '@stores/useSearchStore.ts';
import { useFilterStore } from '@stores/useFilterStore.ts';

const { mapIsVisible } = storeToRefs(useSearchStore());
const { isFilterOpen } = storeToRefs(useFilterStore());
</script>

<template>
  <div>
    <div
      v-if="isFilterOpen"
      class="fixed inset-0 z-10 hidden bg-black/50 lg:block"
    />

    <SearchFilters class="w-full" />

    <div
      :class="[
        'px-6',
        'flex gap-x-6'
      ]"
    >
      <SearchList />

      <SearchMap
        v-if="mapIsVisible"
        class="flex-1"
      />
    </div>
  </div>
</template>
